<template>
  <div
    class="page flex-col"
    style="
      background: url(/static/loginBg1.jpg) no-repeat;
      background-size: 100% 100vh;
      height: auto;
      padding-bottom: 30px;
    "
  >
    <div class="containBox">
      <div class="tittleName">
        <div>
          <el-image
            style="width: 156px; height: 80px"
            :src="loginImg"
            fit="contain"></el-image>
        </div>
        <div style="line-height: 90px">
          天禄云枢古籍数据库
        </div>
      </div>
      <div :class="{'mainBox':true}">
        <div :class="{'tabBox':true,'tabListMy':isactive==='1','tabListPart':isactive==='2'}">
          <div :class="{'tabList':true,'tabListActive':isactive==='1'}" @click="changeType('1')">个人用户</div>
          <div :class="{'tabList':true,'tabListActive':isactive==='2'}" @click="changeType('2')">机构用户</div>
        </div>
        <div v-show="isactive==='1'" class="mainBox2">
          <!--        手机号+密码  -->
          <div class="login-container" v-show="loginType==='phoneKey'">
            <el-form :model="loginForm" :rules="rules" ref="loginForm">
              <!-- 区号+手机号组合输入 -->
              <el-form-item prop="mobile">
                <el-input v-model="loginForm.mobile" placeholder="请输入手机号">
                  <el-select
                    v-model="loginForm.areaCode"
                    slot="prepend"
                    style="width: 120px"
                    placeholder="选择区号"
                    @change="handleAreaCodeChange"
                  >
                    <el-option
                      v-for="item in codeList"
                      :key="item"
                      :value="item"
                      :label="'+' + item"
                    />
                  </el-select>
                </el-input>
              </el-form-item>

              <!-- 密码输入（带眼睛图标） -->
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                  show-password
                >
                  <!--                  <i
                                      slot="suffix"
                                      class="el-icon-view password-icon"
                                      :class="{ 'active': showPassword }"
                                      @click="togglePassword"
                                    />-->
                </el-input>
              </el-form-item>
              <div class="tipBox">
                <div @click="newUser('phone')">新用户注册</div>
                <div @click="newWord('phone')">忘记密码</div>
              </div>
              <div @click="handleLogin" class="buttonBox" v-loading="loading">登录</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked"
                ><span class="bfore">閲讀并同意</span><span @click="goAgreement">使用條款與隱私政策</span></el-checkbox
                >
              </div>
            </el-form>
          </div>
          <!--       手机号+验证码   -->
          <div class="login-container" v-show="loginType==='phoneKeyCode'">
            <el-form :model="loginForm2" :rules="rules2" ref="loginForm2">
              <!-- 区号+手机号组合输入 -->
              <el-form-item prop="mobile">
                <el-input v-model="loginForm2.mobile" placeholder="请输入手机号">
                  <el-select
                    v-model="loginForm2.areaCode"
                    slot="prepend"
                    style="width: 120px"
                    placeholder="选择区号"
                    @change="handleAreaCodeChange"
                  >
                    <el-option
                      v-for="item in codeList"
                      :key="item"
                      :value="item"
                      :label="'+' + item"
                    />
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="smsCode">
                <div class="code-input-group">
                  <el-input
                    style="width: 65%"
                    v-model="loginForm2.smsCode"
                    placeholder="请输入验证码"
                  ></el-input>
                  <el-button
                    class="send-btn"
                    :disabled="!canSend || countdown > 0"
                    @click="sendSMSCode"
                  >
                    {{ countdownText }}
                  </el-button>
                </div>
              </el-form-item>
              <div class="tipBox">
                <div @click="newUser('phone')">新用户注册</div>
                <div @click="newWord('phone')">忘记密码</div>
              </div>
              <div @click="handleLogin2" class="buttonBox" v-loading="loading2">登录</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked2"
                ><span class="bfore">閲讀并同意</span><span @click="goAgreement">使用條款與隱私政策</span></el-checkbox
                >
              </div>
            </el-form>
          </div>
          <!--        邮箱密码登录  -->
          <div class="login-container" v-show="loginType==='emailKey'">
            <el-form :model="loginForm3" :rules="rules3" ref="loginForm3">
              <!-- 区号+手机号组合输入 -->
              <el-form-item prop="email">
                <el-input
                  v-model="loginForm3.email"
                  placeholder="请输入邮箱地址"
                  prefix-icon="el-icon-message"
                  clearable
                ></el-input>
              </el-form-item>

              <!-- 密码输入（带眼睛图标） -->
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm3.password"
                  placeholder="请输入密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <div class="tipBox">
                <div @click="newUser('email')">新用户注册</div>
                <div @click="newWord('email')">忘记密码</div>
              </div>
              <div @click="handleLogin3" class="buttonBox" v-loading="loading3">登录</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked3"
                ><span class="bfore">閲讀并同意</span><span @click="goAgreement">使用條款與隱私政策</span></el-checkbox
                >
              </div>
            </el-form>
          </div>
          <div class="loginType">
            <div class="loginTypeName">
              其他登录
            </div>
            <div class="loginFlag" v-show="loginType!=='emailKey'" @click="loginSure('emailKey')"><i class="el-icon-message"></i></div>
            <div  class="loginFlag" v-show="loginType!=='phoneKey'" @click="loginSure('phoneKey')"><i class="el-icon-mobile-phone" ></i></div>
            <div  class="loginFlag" v-show="loginType!=='phoneKeyCode'" @click="loginSure('phoneKeyCode')"><i class="el-icon-mobile-phone" ></i></div>
            <div class="loginFlag" @click="gotoDaoke">
              <el-image
                style="width: 24px; height: 24px;margin: 12px"
                :src="daokeImg"
                fit=" contain"></el-image>
            </div>
          </div>
        </div>
        <div v-show="isactive==='2'" class="mainBox2">
          <!--        账号+密码  -->
          <div class="login-container">
            <el-form :model="loginForm4" :rules="rules4" ref="loginForm4">
              <el-form-item prop="username">
                <el-input
                  v-model="loginForm4.username"
                  placeholder="请输入账号"
                  prefix-icon="el-icon-s-custom"
                  clearable
                ></el-input>
              </el-form-item>

              <!-- 密码输入（带眼睛图标） -->
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm4.password"
                  placeholder="请输入密码"
                  show-password
                >
                </el-input>
              </el-form-item>
              <div @click="handleLogin4" class="buttonBox">登录</div>
              <div class="layer6 flex-row justify-between" style="margin-top: 10px;padding: 0 15px">
                <el-checkbox class="checked" v-model="checked4"
                ><span class="bfore">閲讀并同意</span><span @click="goAgreement">使用條款與隱私政策</span></el-checkbox
                >
              </div>
            </el-form>
          </div>
          <!--         <div class="loginType">
                     <div class="loginTypeName">
                       其他登录
                     </div>
                     <div class="loginFlag"><i class="el-icon-message"></i></div>
                     <div  class="loginFlag"><i class="el-icon-mobile-phone"></i></div>
                     <div  class="loginFlag"><i class="el-icon-mobile-phone"></i></div>
                     <div class="loginFlag">
                       <el-image
                         style="width: 24px; height: 24px;margin: 12px"
                         :src="daokeImg"
                         fit=" contain"></el-image>
                     </div>
                   </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getPhoneCode,
  pwLogin,
  getPhoneKeyCode,
  keyCodeLogin,
  pwLoginEmail,
  pwLoginJG
} from "@/api/api"
import eventBus from "@/utils/eventBus.js"
export default {
  name: "loginOpen",
  data () {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }

      // 根据不同区号使用不同验证规则
      let areaCode = ''
      if(this.loginType==='phoneKey'){
        areaCode = this.loginForm.areaCode
      }else if(this.loginType==='phoneKeyCode'){
        areaCode = this.loginForm2.areaCode
      }

      let regex

      switch(areaCode) {
        case '86': // 中国
          regex = /^1[3-9]\d{9}$/
          break
        case '1': // 美国
          regex = /^\d{10}$/
          break
        // 其他区号规则...
        default:
          regex = /^\d{6,15}$/ // 默认通用规则
      }
      console.log(value)
      console.log(areaCode)
      //console.log(value.replace(/^\+?\d+\s*/, ''))
      console.log(regex.test(value))
      if (!regex.test(value)) {
        return callback(new Error(`请输入有效的手机号`))
      }

      callback()
    }
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return callback(new Error('请输入有效的邮箱地址'));
      }
      callback();
    };
    // 自定义密码校验
    const validatePassword=(rule, value, callback)=> {
      if (!value) {
        return callback(new Error('请输入密码'));
      }

      // 长度校验
      if (value.length < 8 || value.length > 16) {
        return callback(new Error('密码长度需在8-16位之间'));
      }

      // 复杂度校验
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);

      if (!hasUpperCase) {
        return callback(new Error('必须包含至少一个大写字母'));
      }
      if (!hasLowerCase) {
        return callback(new Error('必须包含至少一个小写字母'));
      }
      if (!hasNumber) {
        return callback(new Error('必须包含至少一个数字'));
      }

      callback();
    };
    return {
      isactive:'1',
      loading:false,
      loading2:false,
      loading3:false,
      loading4:false,
      loginType:'phoneKey',
      loginForm: {
        areaCode: '86', // 默认中国区号
        mobile: '',
        password: ''
      },
      loginForm2: {
        areaCode: '86', // 默认中国区号
        mobile: '',
        smsCode: '',
        uuid:''
      },
      loginForm3: {
        email: '',
        password: ''
      },
      loginForm4: {
        username: '',
        password: '',
      },
      showPassword: false,
      rules: {
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      rules2: {
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        smsCode: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
      },
      rules3: {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      rules4: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      codeList: [],
      checked: false,
      checked2: false,
      checked3: false,
      checked4: false,
      loginImg:'/static/loginNew.png',
      daokeImg:'/static/daokeLogin.png',
      countdown: 0,          // 倒计时秒数
      lastSendTime: null,     // 上次发送时间戳
      canSend: true          // 能否发送验证码
    }
  },
  computed: {
    // 倒计时显示文本
    countdownText() {
      return this.countdown > 0 ? `${this.countdown}s后重新获取` : '获取验证码';
    }
  },
  mounted () {
    getPhoneCode().then(res => {
      this.codeList = res.data || []
      this.ac = this.codeList[0] || ""
    })
    localStorage.setItem('forword', this.$route.query.forword ? this.$route.query.forword : "/")
  },
  methods:{
    goAgreement(){
      let routeData = this.$router.resolve({
        path: "/agreement",
      })
      window.open(routeData.href, "_blank")
    },
    newUser(type){
      this.$emit("closeOpen")
      this.$router.push({
        name: 'Regist',
        query: {
          type
        },
      })
    },
    newWord(type){
      this.$emit("closeOpen")
      this.$router.push({
        name: 'ResetWord',
        query: {
          type
        },
      })
    },

    gotoDaoke () {
//let redirectUri = encodeURIComponent('http://tlgj.bbtpress.com/')
        let protocol = window.location.protocol
        let redirectHost=protocol+'//'+window.location.host+'/'
        let redirectUri=encodeURIComponent(redirectHost)
      window.location.href = `https://tlys.duxiuai.com/oauth2/authorize?response_type=code&client_id=4&redirect_uri=` + redirectUri + `&scope=userinfo,unionid&clientSecret=2sXFZWp22xerrJ6FbhTTFRtNt58PCFr5GKKWRiNJzh4W247hb535R4sy3wMY`
    },
    loginSure(type){
      this.loginType=type
      this.loginForm={
        areaCode: '86', // 默认中国区号
        mobile: '',
        password: ''
      }
      this.loginForm2= {
        areaCode: '86', // 默认中国区号
        mobile: '',
        smsCode: '',
        uuid:''
      }
      this.loginForm3={
        email: '',
        password: ''
      }
      this.loginForm4= {
        username: '',
        password: '',
      }
      this.checked= false
      this.checked2= false
      this.checked3=false
      this.checked4=false
    },
    changeType(type){
      console.log(type)
      this.isactive=type
      this.loginForm={
        areaCode: '86', // 默认中国区号
        mobile: '',
        password: ''
      }
      this.loginForm2= {
        areaCode: '86', // 默认中国区号
        mobile: '',
        smsCode: '',
        uuid:''
      }
      this.loginForm3={
        email: '',
        password: ''
      }
      this.loginForm4= {
        username: '',
        password: '',
      }
      this.checked= false
      this.checked2= false
      this.checked3=false
      this.checked4=false
    },
    // 区号变化处理
    handleAreaCodeChange(type) {
      if(type='phoneKey'){
        this.loginForm.mobile = '' // 清空手机号输入
        this.$refs.loginForm.clearValidate('mobile') // 清除验证状态
      }

    },
    // 手机号密码登录提交
    async handleLogin() {
      if (!this.checked) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      try {
        await this.$refs.loginForm.validate()

        // 提取纯手机号（去除区号部分）
        const purePhone = this.loginForm.mobile.replace(/^\+?\d+\s*/, '')
        console.log(this.loginForm.mobile)
        // 组装提交数据
        const params = {
          //areaCode: this.loginForm.areaCode,
          mobile: `+${this.loginForm.areaCode}${this.loginForm.mobile}`,
          password: this.loginForm.password
        }
        this.loading=true
        // 调用登录API
        pwLogin(params).then(res => {
          this.loading=false
          if(res.code === 200){
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            eventBus.$emit("doChangeloginVisible", false)
            this.$message.success("登録成功")
            if (this.$route.path == '/login') {
              this.$router.replace({
                path: this.$route.query.forword ? this.$route.query.forword : '/'
              })
            } else if (this.$route.path == '/search') {
              this.$bus.$emit("reloadSearch", true)
            } else {
              location.reload()
            }

          }else{
            this.loading=false
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading=false
        console.error('登录失败:', error)
      }
    },
    // 发送短信验证码
    async sendSMSCode() {
      try {
        // 验证手机号格式
        await this.$refs.loginForm2.validateField('mobile');

        // 检查发送频率（60秒内只能发一次）
        const now = Date.now();
        if (this.lastSendTime && now - this.lastSendTime < 60000) {
          this.$message.warning('操作过于频繁，请稍后再试');
          return;
        }

        // 开始倒计时
        this.startCountdown();
        this.lastSendTime = now;

        // 调用发送验证码API
        getPhoneKeyCode({
          mobile: `+${this.loginForm2.areaCode}${this.loginForm2.mobile}`,
        }).then(res => {
          if(res.code === 200){
            this.loginForm2.uuid=res.uuid
            this.$message.success('验证码已发送');
          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.$message.error(error.message || '发送失败');
      }
    },

    // 开始60秒倒计时
    startCountdown() {
      this.countdown = 60;
      this.canSend = false;

      const timer = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          clearInterval(timer);
          this.canSend = true;
        }
      }, 1000);
    },

    // 手机号验证码处理登录
    async handleLogin2() {
      if (!this.checked2) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      try {
        await this.$refs.loginForm2.validate();

        const params = {
          //areaCode: this.loginForm.areaCode,
          mobile: `+${this.loginForm2.areaCode}${this.loginForm2.mobile}`,
          uuid: this.loginForm2.uuid,
          smsCode: this.loginForm2.smsCode
        }
        this.loading2=true
        // 调用登录API
        keyCodeLogin(params).then(res => {
          this.loading2=false
          if(res.code === 200){
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            eventBus.$emit("doChangeloginVisible", false)
            this.$message.success("登録成功")
            if (this.$route.path == '/login') {
              this.$router.replace({
                path: this.$route.query.forword ? this.$route.query.forword : '/'
              })
            } else if (this.$route.path == '/search') {
              this.$bus.$emit("reloadSearch", true)
            } else {
              location.reload()
            }
            /* if (this.$route.path == '/login') {
               this.$router.replace({
                 path: this.$route.query.forword ? this.$route.query.forword : '/'
               })
             } else if (this.$route.path == '/search') {
               this.$bus.$emit("reloadSearch", true)
             } else {
               location.reload()
             }*/

          }else{
            this.loading2=false
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading2=false
        this.$message.error('登录失败');
      }
    },
    //邮箱登录
    // 处理登录
    async handleLogin3() {
      if (!this.checked3) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      try {
        const valid = await this.$refs.loginForm3.validate();
        if (!valid) return;

        this.loading3 = true;

        // 调用登录API
        pwLoginEmail(this.loginForm3).then(res => {
          this.loading3=false
          if(res.code === 200){
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            eventBus.$emit("doChangeloginVisible", false)
            this.$message.success("登録成功")
            this.$router.push({
              name: 'Home'
            })
            /*if (this.$route.path == '/login') {
              this.$router.replace({
                path: this.$route.query.forword ? this.$route.query.forword : '/'
              })
            } else if (this.$route.path == '/search') {
              this.$bus.$emit("reloadSearch", true)
            } else {
              location.reload()
            }*/

          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading3=false
        this.$message.error('登录失败');
      } finally {
        this.loading3 = false;
      }
    },
    async handleLogin4() {
      if (!this.checked4) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      try {
        const valid = await this.$refs.loginForm4.validate();
        if (!valid) return;

        this.loading4 = true;

        // 调用登录API
        pwLoginJG(this.loginForm4).then(res => {
          this.loading4=false
          if(res.code === 200){
            localStorage.setItem("token", "Bearer " + res.token)
            eventBus.$emit("getUserInfo")
            eventBus.$emit("doChangeloginVisible", false)
            this.$message.success("登録成功")
            this.$router.push({
              name: 'Home'
            })
            /*if (this.$route.path == '/login') {
              this.$router.replace({
                path: this.$route.query.forword ? this.$route.query.forword : '/'
              })
            } else if (this.$route.path == '/search') {
              this.$bus.$emit("reloadSearch", true)
            } else {
              location.reload()
            }*/

          }else{
            this.$message.error(res.msg)
          }
        })
      } catch (error) {
        this.loading3=false
        this.$message.error('登录失败');
      } finally {
        this.loading3 = false;
      }
    },
  }
}

</script>
<style lang="less" scoped>
/deep/.el-input-group__prepend div.el-select .el-input__inner{
  background-color: #fff;
  border:1px solid #DBB054;
  border-right: none;
  border-radius: 4px 0 0 4px;
}
/deep/.el-form-item.is-error .el-input__inner{
  border: 1px solid #DBB054;
}
/deep/.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner{
  border: 1px solid #DBB054;
  border-right: none;
}
/deep/.el-input__inner{
  height: 48px;
  line-height: 48px;
  border: 1px solid #DBB054;
}
/deep/.el-form-item__content{
  line-height: 48px;
}
/deep/.el-input__suffix{
  right: 15px;
}
/deep/ .el-checkbox__label {
  color: #795636;
  font-size: 0.81rem;
  font-weight: 400;
  font-family: FZShuSong-Z01T;
  .bfore {
    color: #2B2B2B;
  }
}
/deep/ .el-checkbox__inner {
  border: 1px solid #DBB054;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-checked.is-focus .el-checkbox__inner{
  border: 1px solid #DBB054;
  background-color: #DBB054;
}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #795636;
}
.page {
  position: relative;
  width: 100%;
  height: 100vh;
  //background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  /* display: flex;
   justify-content: center;
   align-items: center;*/
  font-family: "Courier New", Courier, monospace;
  .containBox{
    width: 577px;
    //height: 630px;
    margin: auto;
    .tittleName{
      display: flex;

      font-family: STSongti-SC, STSongti-SC;
      font-weight: 900;
      font-size: 32px;
      color: #36240C;
      text-align: center;
    }
    .mainBox{
      .tabBox{
        margin-top: -10px;
        display: flex;
        //justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #573E0D;
        line-height: 70px;
        .tabList{
          color: #fff;
          //margin-right: 20px;
          width: 50%;
          text-align: center;
        }
        .tabListActive{
          color: #573E0D;
          //border-bottom: 3px solid #634427;
        }
      }
      .tabListMy{
        background: url(/static/tabMy.png) no-repeat;
        background-size: 100%;
      }
      .tabListPart{
        background: url(/static/tabPart.png) no-repeat;
        background-size: 100%;
      }
      .mainBox2{
        background-color: #EDE4D3;
        padding: 26px 0;
        border-radius: 0 0 25px 25px;
        .login-container{
          width: 433px;
          margin: 0 auto;
          .tipBox{
            display: flex;
            justify-content: space-between;
            align-items: center;
            //line-height:40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #795636;
            margin-top: -10px;
            padding: 0 15px;
          }
          .buttonBox{
            height: 48px;
            line-height: 48px;
            text-align: center;
            border-radius: 4px;
            background-color: #F9CE68;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #573E0D;
            margin-top: 10px;
          }
          .send-btn{
            height: 48px;
            background-color: #F9CE68;
            border: none;
            color: #573E0D;
          }
        }
        .loginType{
          display: flex;
          width: 533px;
          margin:26px 0 0 70px;
          .loginTypeName{
            margin-left: 15px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #2B2B2B;
            line-height: 48px;
          }
          .loginFlag{
            width: 48px;
            height: 48px;
            background: #E8CD8E;
            border-radius: 50%;
            margin-left: 15px;
            font-size: 24px;
            i{
              color: #573E0D;
              margin: 12px;
            }
          }
        }
      }


    }

  }
}
</style>




// WEBPACK FOOTER //
// src/components/loginOpen.vue